var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md user-audio"},[_c('a',{attrs:{"href":"http://www.fpc.com.tw/fpcw/index.php?op=proD","target":"_blank","title":_vm.$t('site.func.file')}})])}
var staticRenderFns = []

export { render, staticRenderFns }